// extracted by mini-css-extract-plugin
module.exports = {"nft":"BuyNft_nft__krLx4"};